<template>
  <div
    class="modal fade"
    id="newTestModal"
    tabindex="-1"
    aria-labelledby="newTestModalLabel"
    aria-hidden="true"
    ref="modalRef"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content new-test-dialog">
        <div class="modal-header border-0 pb-0">
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body text-center px-4 pb-4">
          <div class="dialog-icon mb-3">
            <i class="fas fa-clipboard-list"></i>
          </div>
          <h4 class="dialog-title mb-4">
            {{ $t("qbank.new_test.choose_type") }}
          </h4>

          <div class="d-grid gap-3">
            <button
              class="btn btn-option btn-custom-test"
              @click="openCustomTest"
              data-bs-dismiss="modal"
            >
              <i class="fas fa-edit me-2"></i>
              {{ $t("qbank.new_test.create_custom") }}
            </button>

            <button
              class="btn btn-option btn-predefined-test"
              @click="openPredefinedTests"
              data-bs-dismiss="modal"
            >
              <i class="fas fa-list-alt me-2"></i>
              {{ $t("qbank.new_test.pick_predefined") }}
            </button>

            <div class="divider my-2">
              <span>{{ $t("common.or") }}</span>
            </div>

            <button class="btn btn-cancel" data-bs-dismiss="modal">
              {{ $t("common.cancel") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NewTestDialog",
  props: {
    subscriptionPlanId: {
      type: [Number, String],
      required: true,
    },
  },
  emits: ["refresh"],
  methods: {
    openCustomTest() {
      this.$router.push({
        path: "/qbank-create-test",
        query: { subscriptionId: this.subscriptionPlanId },
      });
    },
    openPredefinedTests() {
      this.$router.push({
        path: "/qbank-predefined-tests",
        query: { subscriptionId: this.subscriptionPlanId },
      });
    },
    show() {
      const modal = new bootstrap.Modal(this.$refs.modalRef);
      modal.show();
    },
  },
};
</script>

<style scoped>
.new-test-dialog {
  border-radius: 20px;
  border: none;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
  overflow: hidden;
}

.dialog-icon {
  width: 70px;
  height: 70px;
  background: linear-gradient(135deg, #00c744 0%, #00a83b 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  box-shadow: 0 8px 25px rgba(0, 199, 68, 0.3);
}

.dialog-icon i {
  font-size: 28px;
  color: white !important;
}

/* Force white icons in buttons */
.btn-option i {
  color: white !important;
}

.dialog-title {
  color: #2d3748;
  font-weight: 700;
  font-size: 1.25rem;
}

.btn-option {
  padding: 14px 20px;
  border-radius: 12px;
  font-weight: 600;
  font-size: 1rem;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn-custom-test {
  background: linear-gradient(135deg, #00c744 0%, #00a83b 100%);
  color: white;
  border: none;
  box-shadow: 0 6px 20px rgba(0, 199, 68, 0.3);
}

.btn-custom-test:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 30px rgba(0, 199, 68, 0.4);
  color: white;
}

.btn-predefined-test {
  background: #10b981;
  color: white;
  border: none;
  box-shadow: 0 6px 20px rgba(16, 185, 129, 0.3);
}

.btn-predefined-test:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 30px rgba(16, 185, 129, 0.4);
  background: #059669;
  color: white;
}

.btn-cancel {
  background: #f1f5f9;
  color: #64748b;
  border: none;
  padding: 12px 20px;
  border-radius: 12px;
  font-weight: 600;
}

.btn-cancel:hover {
  background: #e2e8f0;
  color: #475569;
}

.divider {
  display: flex;
  align-items: center;
  text-align: center;
  color: #94a3b8;
  font-size: 0.85rem;
}

.divider::before,
.divider::after {
  content: "";
  flex: 1;
  border-bottom: 1px solid #e2e8f0;
}

.divider span {
  padding: 0 12px;
}

/* RTL Support */
[dir="rtl"] .btn-option i {
  margin-left: 8px;
  margin-right: 0;
}

/* Dark Mode */
[data-bs-theme="dark"] .new-test-dialog,
.dark .new-test-dialog {
  background: #1e293b;
}

[data-bs-theme="dark"] .dialog-title,
.dark .dialog-title {
  color: #f1f5f9;
}

[data-bs-theme="dark"] .btn-cancel,
.dark .btn-cancel {
  background: #334155;
  color: #94a3b8;
}

[data-bs-theme="dark"] .btn-cancel:hover,
.dark .btn-cancel:hover {
  background: #475569;
  color: #e2e8f0;
}

[data-bs-theme="dark"] .divider,
.dark .divider {
  color: #64748b;
}

[data-bs-theme="dark"] .divider::before,
[data-bs-theme="dark"] .divider::after,
.dark .divider::before,
.dark .divider::after {
  border-bottom-color: #334155;
}
</style>
